export default class DynamicWeightPriceRange {

  /**
   * A dynamic weight price range. This weight will be considered as the weight of the position when the price of the position is within this price range interval.
   * @param id GUID of this object.
   * @param dynamicWeightId The id of the dynamic weight to which this price range belongs to.
   * @param priceMax The maximum price until which this weight should be used.
   * @param weight The weight to be applied for this price range.
   */
  constructor(
    public id: string | undefined,
    public dynamicWeightId: string | undefined,
    public priceMax: number,
    public weight: number
  ) {

  }
}